import { EnvMicroNotifications } from 'lib-klab-core';

export const envKlabNotificationsLocal: EnvMicroNotifications = {
  host: '/ms-notifications',
  apiBasePath: '/notifications',
  streamPath: '/stream',
};

export const envKlabNotificationsDev: EnvMicroNotifications = {
  host: 'https://gatewayapi-dev.klab.inclub.world',
  apiBasePath: '/ms-notifications/notifications',
  streamPath: '/stream',
};

export const envKlabNotificationsProd: EnvMicroNotifications = {
  host: 'https://gatewayapi.klab.inclub.world',
  apiBasePath: '/ms-notifications/notifications',
  streamPath: '/stream',
};
